import {
  PA_FETCH_ALL_TRAINERS,
  PA_FETCH_ALL_TRAINERS_SUCCESS,
  PA_FETCH_ALL_TRAINERS_FAILURE,
  PA_NEXT_FORM_STEP,
  PA_PREVIOUS_FORM_STEP,
  PA_RESET_FORM_STEP,
  UPDATE_CURRENT_TRAINING_CENTER_ID,
  RESET_CURRENT_TRAINING_CENTER_ID,
  PA_FETCH_TRAINER_BY_ID,
  PA_FETCH_TRAINER_BY_ID_SUCCESS,
  PA_FETCH_TRAINER_BY_ID_FAILURE,
  PA_RESET_TRAINER_BY_ID,

  PHYSICALLY_APPROVE_TRAINER,
  PHYSICALLY_APPROVE_TRAINER_SUCCESS,
  PHYSICALLY_APPROVE_TRAINER_FAILURE,
  PHYSICALLY_APPROVE_TRAINER_RESET,

  EXPORT_PHYSICALLY_APPROVED_TRAINERS,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS_SUCCESS,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS_FAILURE,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS_RESET,
} from '../ActionTypes';


export const paFetchAllTrainers = payload => ({
  type: PA_FETCH_ALL_TRAINERS,
  payload
})

export const paFetchAllTrainersSuccess = payload => ({
  type: PA_FETCH_ALL_TRAINERS_SUCCESS,
  payload
})

export const paFetchAllTrainersFailure = payload => ({
  type: PA_FETCH_ALL_TRAINERS_FAILURE,
  payload
})

export const paNextFormStep = payload => ({
  type: PA_NEXT_FORM_STEP,
  payload
})

export const paPreviousFormStep = payload => ({
  type: PA_PREVIOUS_FORM_STEP,
  payload
})

export const paResetFormStep = payload => ({
  type: PA_RESET_FORM_STEP,
  payload
})

export const updateCurrentTrainingCenterId = payload => ({
  type: UPDATE_CURRENT_TRAINING_CENTER_ID,
  id: payload
})

export const resetCurrentTrainingCenterId = () => ({
  type: RESET_CURRENT_TRAINING_CENTER_ID,
})

export const paFetchTrainerById = (payload) => ({
  type: PA_FETCH_TRAINER_BY_ID,
  payload
})


export const paFetchTrainerByIdSuccess = (payload) => ({
  type: PA_FETCH_TRAINER_BY_ID_SUCCESS,
  payload
})


export const paFetchTrainerByIdFailure = (payload) => ({
  type: PA_FETCH_TRAINER_BY_ID_FAILURE,
  payload
})

export const paResetTrainerById = (payload) => ({
  type: PA_RESET_TRAINER_BY_ID,
  payload
})


export const physicallyApproveTrainer = (payload) => ({
  type: PHYSICALLY_APPROVE_TRAINER,
  payload
})

export const physicallyApproveTrainerSuccess = (payload) => ({
  type: PHYSICALLY_APPROVE_TRAINER_SUCCESS,
  payload
})

export const physicallyApproveTrainerFailure = (payload) => ({
  type: PHYSICALLY_APPROVE_TRAINER_FAILURE,
  payload
})

export const physicallyApproveTrainerReset = (payload) => ({
  type: PHYSICALLY_APPROVE_TRAINER_RESET,
  payload
})

export const exportPhysicallyApprovedTrainers = payload => ({
  type: EXPORT_PHYSICALLY_APPROVED_TRAINERS,
  payload
})

export const exportPhysicallyApprovedTrainersSuccess = payload => ({
  type: EXPORT_PHYSICALLY_APPROVED_TRAINERS_SUCCESS,
  payload
})

export const exportPhysicallyApprovedTrainersFailure = payload => ({
  type: EXPORT_PHYSICALLY_APPROVED_TRAINERS_FAILURE,
  payload
})

export const exportPhysicallyApprovedTrainersReset = payload => ({
  type: EXPORT_PHYSICALLY_APPROVED_TRAINERS_RESET,
  payload
})
